/* eslint-disable */
import { useEffect } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Select from "react-select";
import { Field, useFormState } from "react-final-form";
import useCustomerHook from "../../../customers/useCustomerHook";
import DatePicker from "react-datepicker";
const BasicInvoiceDetailsForm = ({ status }) => {
  const { customers } = useCustomerHook();
  const { values } = useFormState();
  const formattedOptions = (options) =>
    options?.map((option) => ({
      value: option.id,
      label: `${option?.user?.full_name} (${option?.customer_code})`,
      data: option,
    }));

  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("w-100"));
  }, []);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form-group-item border-0 mb-0">
          <div className="row align-item-center">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>
                  Customer Name <span style={{ color: "red" }}>*</span>
                </label>
                <ul className="form-group-plus css-equal-heights">
                  <li>
                    <Field
                      name="customer"
                      validate={(value) =>
                        value ? undefined : "Customer is required"
                      }
                    >
                      {({ input, meta }) => {
                        let selectedOption = null;
                        const options = formattedOptions(customers);
                        if (typeof input.value === "string") {
                          selectedOption =
                            options?.find((opt) => opt.value === input.value) ||
                            null;
                        } else {
                          selectedOption = input.value;
                        }
                        return (
                          <Select
                            {...input}
                            value={selectedOption}
                            onChange={input.onChange}
                            options={options}
                            placeholder="Choose Customer"
                            required
                          />
                        );
                      }}
                    </Field>
                  </li>
                  <li>
                    <Link
                      className="btn btn-primary "
                      to="/customers/add-customer"
                    >
                      <FeatherIcon icon="plus-circle" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>
                  Invoice Date <span style={{ color: "red" }}>*</span>
                </label>
                <div className="cal-icon cal-icon-info">
                  <Field
                    name="invoice_date"
                    validate={(value) =>
                      value ? undefined : "Invoice date is required"
                    }
                  >
                    {({ input, meta }) => (
                      <DatePicker
                        className="datetimepicker form-control"
                        selected={input.value}
                        onChange={input.onChange}
                        dateFormat="dd/MM/yyyy"
                        disabledPast
                        required
                        

                      />
                    )}
                  </Field>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>Reference Number </label>
                <Field
                  name="reference_number"
                  component="input"
                  type="text"
                  className="form-control"
                  placeholder="Enter Reference Number"
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>Airway/Sea-way/B/L Number</label>
                <Field
                  name="airway_number"
                  component="input"
                  type="text"
                  className="form-control"
                  placeholder="Enter Airway/Sea-way/B/L number"
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="input-block mb-3">
                <label>QR Link URL</label>
                <Field
                  name="qr_link_url"
                  component="input"
                  type="text"
                  className="form-control"
                  placeholder="Enter QR Link URL"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInvoiceDetailsForm;
